import {Routes} from '@angular/router';
import {CallsComponent} from './components/calls/calls.component';


export const REPORTING_ROUTES: Routes = [
    {path: 'reporting/calls', component: CallsComponent}
];



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/reporting/reporting.routes.ts